import * as React from 'react';

import { useFilterContext } from '../../contexts/FiltersContext';
import { BaseFilterComponent } from '../../models/Filter';
import BaseFilterChip from './BaseFilterChip';

type TitleFilterChipProps = {
  filter: BaseFilterComponent;
  value: string | boolean;
};

const TitleFilterChip = ({ filter }: TitleFilterChipProps) => {
  const { handleRemoveFilter } = useFilterContext();

  // Derived State
  const chipTitleText = filter.attributeText;

  return (
    <BaseFilterChip
      filter={filter}
      onRemove={() => {
        filter.removeFn();
        handleRemoveFilter(filter);
      }}
      text={chipTitleText}
    />
  );
};

export default TitleFilterChip;
